/**
 * Filter products with same variant id
 *
 * @param {array} products
 */
export const filterProductsWithSameVariant = (products) => {
    if (!products || !Array.isArray(products)) {
        return [];
    }

    const variantIds = [];

    return products.filter((product) => {
        const variantId = product.variant_id || product.variants?.[0].id;

        if (!variantIds.includes(variantId)) {
            variantIds.push(variantId);
            return true;
        }

        return false;
    });
};
